
import { NotificationManager } from "src/util/notify";
import moment from 'moment';

export function isString(variable) { return typeof variable === 'string' || variable instanceof String }

export function showError(error, tag) {
    let message = ""
    if (isString(error)) {
        message = error
    }
    else if (error && error.message && isString(error.message)) {
        message = error.message
    }
    NotificationManager.error(tag ? `${tag} -> ${message}` : message)
}

export function convertToUtcMorning(date /* 2022-08-22T18:30:00.000Z */) {
    const momentObj = moment(date)
    momentObj.set('hour', 0);
    momentObj.set('minute', 0);
    momentObj.set('second', 0);
    momentObj.set('millisecond', 0);
    return momentObj.utc()
}

export function convertToUtcNight(date /* 2022-08-22T18:30:00.000Z */) {
    const momentObj = moment(date)
    momentObj.set('hour', 23);
    momentObj.set('minute', 59);
    momentObj.set('second', 59);
    momentObj.set('millisecond', 999);
    return momentObj.utc()
}

export function displayDateFromUtcDate(utcDate /* 2022-07-28T06:31:51.95 */, format) {

    const momentObj = moment.utc(utcDate).local()
    const year = momentObj.year()
    const month = momentObj.month() + 1
    const date = momentObj.date()

    const curMomentObj = moment(new Date())
    const curYear = curMomentObj.year()
    const curMonth = curMomentObj.month() + 1
    const curDate = curMomentObj.date()

    if (format) {
        return momentObj.format(format)
    }
    if (curYear > year) {
        return momentObj.format("YYYY-MM-DD")
    }
    else if (curMonth > month || curDate > date) {
        return momentObj.format("MMM DD")
    }
    else {
        return momentObj.format("hh:mm a")
    }
}

export function displayDate(date /* Date Object */, format) {
    const momentObj = moment(date)
    return momentObj.format(format)
}

export function displayDateMMDDYYYY(date /* Date Object */) {
    return displayDate(date, "MM/DD/YYYY")
}

export function displayTime(date /* Date Object */) {
    return displayDate(date, "hh:mm a")
}
